import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import ServicesHero from "../components/services/ServicesHero";
import ServiceSection from "../components/services/ServiceSection";
import { servicesData } from "../data/servicesData";

const Services = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Handle smooth scrolling when URL has a hash
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.slice(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
    
    // Preload all service images immediately
    servicesData.forEach(service => {
      const img = new Image();
      img.src = service.imageSrc;
      img.fetchPriority = "high";
      img.decoding = "async";
    });
  }, [location]);

  return (
    <div className="flex flex-col">
      <Helmet>
        <title>Professional Traffic Control Services | USA Traffic Control</title>
        <meta name="description" content="Comprehensive traffic management solutions including professional flaggers, traffic control plans, equipment rentals, and pilot car services." />
        <meta name="keywords" content="traffic control services, professional flaggers, traffic control plans, pilot car, equipment rental" />
        <link rel="canonical" href="https://usatrafficcontrol.com/services" />
        <meta property="og:title" content="Traffic Control Services | USA Traffic Control" />
        <meta property="og:description" content="Professional traffic management solutions for construction sites, events, and roadwork projects." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      
      <ServicesHero />
      
      {/* Service Sections */}
      {servicesData.map((service, index) => (
        <ServiceSection 
          key={service.id} 
          service={service} 
          index={index} 
        />
      ))}
      
      <Footer />
    </div>
  );
};

export default React.memo(Services);
